import React, { useEffect, useState } from "react";
import { Page, Grid } from "./styles";
import { useHeader } from "components/header/store";

import Card from "./card";
import HypervisorSummary from "components/hypervisorSummary";
import { hypervisorAPI } from "api";

const HypervisorPage = () => {
  const { setTitle, setButtons } = useHeader();

  useEffect(() => {
    setTitle("HYPERVISOR");
    setButtons(null);
  }, [setTitle, setButtons]);

  const [hypervisors, setHypervisors] = useState<string[]>([]);
  const [hypervisorSummary, setHypervisorSummary] = useState(null);

  const [cardStatus, setCardStatus] = useState<
    { name: string; status: "PENDING" | "SUCCESS" | "FAIL" }[]
  >([]);

  const updateCardStatus = (name, status) => {
    setCardStatus((prev) =>
      prev.map((c) => (c.name === name ? { ...c, status } : c))
    );
  };

  useEffect(() => {
    (async () => {
      const res = await hypervisorAPI.getHypervisors();
      const list = res?.data?.data ?? [];

      setHypervisors(list);
      setCardStatus(list.map((name) => ({ name, status: "PENDING" })));

      // const nextSummaryHypervisor = hyper?.data?.data ?? null;
      // setHypervisorSummary(nextSummaryHypervisor);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (cardStatus.length === 0) return;

      const allSuccess = cardStatus.every((c) => c.status === "SUCCESS");

      if (!allSuccess) return;

      if (hypervisorSummary) return;

      const hyper = await hypervisorAPI.getHypervisorSummary();
      const nextSummaryHypervisor = hyper?.data?.data ?? null;
      setHypervisorSummary(nextSummaryHypervisor);
    })();
  }, [cardStatus, hypervisorSummary]);

  return (
    <Page>
      <HypervisorSummary summary={hypervisorSummary} />

      <Grid>
        {hypervisors.map((name, index) => {
          return (
            <Card name={name} index={index} onStatusChange={updateCardStatus} />
          );
        })}
      </Grid>
    </Page>
  );
};

export default HypervisorPage;
